import { render } from "./EmergencyImageModal.vue?vue&type=template&id=2bc22d56&scoped=true&ts=true"
import script from "./EmergencyImageModal.ts?vue&type=script&lang=ts"
export * from "./EmergencyImageModal.ts?vue&type=script&lang=ts"

import "./EmergencyImageModal.scss?vue&type=style&index=0&id=2bc22d56&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc22d56"]])

export default __exports__